import React, { useContext, useCallback, useState, useEffect } from 'react';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { StoreContext } from '../../appContext/StoreProvider';
import { TYPES } from '../../../utils/flattenTree/utils/consts';
import style from '../LibraryView/LibraryView.scss';
import SectionIntersectionDetection from '../SectionIntersectionDetection';
import debounce from 'lodash/debounce';
import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { getNodeDetails } from './getNodeDetails';
import { getRenderers } from './sectionRenderersForBots';
import { getNodeByLink } from '../../../Store/Utils/treeUtils';

export default function LibraryViewForBots({
  withNotificationBar,
  customPath,
}) {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  const { store } = useContext(StoreContext);

  const [parentNode, setParentNode] = useState(
    getNodeByLink(store.getFullTree(), customPath || match.path),
  );
  const [nodeDetails, setNodeDetails] = useState(
    getNodeDetails(location.pathname, store.storePath),
  );

  const onIntersectionHandlerDebounce = useCallback(
    debounce(onIntersectionHandler, 100, { maxWait: 100 }),
    [],
  );

  useEffect(() => {
    setNodeDetails(getNodeDetails(location.pathname, store.storePath));
  }, [location.pathname]);

  return (
    <div className={style.contentWrapper}>
      <SectionIntersectionDetection
        dataHook={`main-apis-view-${parentNode.data.urlFormat}`}
        onIntersection={onIntersectionHandlerDebounce}
        isBot={true}
        withNotificationBar={withNotificationBar}
      >
        {({ subscribeToIntersectionObserver }) =>
          getContentComponent(subscribeToIntersectionObserver)
        }
      </SectionIntersectionDetection>
    </div>
  );

  function getContentComponent(subscribeToIntersectionObserver) {
    const { path, prefix, urlFormat } = nodeDetails;
    const type = getNodeByLink(store.getFullTree(), path)?.data?.propType;

    const prefixNode = prefix
      ? getNodeByLink(store.getFullTree(), prefix)
      : parentNode;

    if (!TYPES[type]) {
      console.error(
        `Type of section ${type} is not found in TYPES enum. No renderer is found. Returning null for the content.`,
      );
      return null;
    }

    const renderers = getRenderers(
      prefixNode,
      prefix,
      urlFormat,
      subscribeToIntersectionObserver,
    );

    if (!renderers[TYPES[type]]) {
      console.error(
        `Type of section ${type} is not found in TYPES enum. No renderer is found. Returning null for the content.`,
      );
      return null;
    }

    return renderers[TYPES[type]]();
  }

  function onIntersectionHandler(entry) {
    const [sectionName] = entry.target.id.split('#');
    const focusLocation = `/${sectionName}`.replace(/^\/+/, '/');
    store.publishToFocusLocation(focusLocation);
    if (location.pathname !== focusLocation) {
      history.push({
        pathname: focusLocation,
        search: location.search,
        hash: location.hash,
        state: { navType: NAV_TYPES.SCROLL },
      });
    }
  }
}
